import "./styles/Agreement.css";
import useScrollTop from "../../hooks/useScrollTop";
import { useTranslation, Trans } from "react-i18next";
import "../../localisation/index"
const PrivacyPolicy = () => {
  useScrollTop();
  const {t} = useTranslation()

  return (
    <div className="component">
      <div className="section-box-container">
        <div className="section-box-title">WEBSITE PRIVACY POLICY</div>
      </div>
      <div className="agreement-component">
        <h2>SCOPE</h2>
        <p>
          <a href="https://www.qwikcilver.com">www.qwikcilver.com</a>
          {t("privacyPolicy.descrption1")}
        </p>
        <p>
          {t("privacyPolicy.description2")}
        </p>
        <h2>{t("privacyPolicy.heading2")}</h2>
        <p>{t("privacyPolicy.description3")}</p>
        <ul>
          <li>{t("privacyPolicy.customer.name")}</li>
          <li>{t("privacyPolicy.customer.email")}</li>
          <li>{t("privacyPolicy.customer.contact")}</li>
          <li>{t("privacyPolicy.customer.address")}</li>
          <li>{t("privacyPolicy.customer.opinion")}</li>
          <li>{t("privacyPolicy.customer.ip")}</li>
          <li>{t("privacyPolicy.customer.preference")}</li>
          <li>{t("privacyPolicy.customer.other")}</li>
        </ul>
        <p>{t("privacyPolicy.info")}</p>
        <ul>
          <li>{t("privacyPolicy.bullet1")}</li>
          <li>the links you click on this Website;</li>
          <li>
            the number of times you access a particular page on this Website;
            and
          </li>
          <li>the number of times you have interacted on this Website.</li>
        </ul>
        <p>
          We may collect your name and billing address when you make payment for
          the Services. All payment information barring the aforesaid (i.e. name
          and address) will be obtained and processed by our online payment
          partners and payment gateways. They have access to personal data
          needed to perform their functions but may not use it for other
          purposes. Further, they must process the personal data in accordance
          with this Privacy Policy and as permitted by applicable law.
        </p>
        <p>
          We may work with third-party analytics services to help us understand
          how this Website is being used, such as tracking the frequency and
          duration of use of the Sites. We may use tracking tools including, but
          not limited to, Google Analytics, Google Webmaster, browser cookies,
          and web beacons to collect information about your use of this Site.
          These Analytics Tools may use cookies to collect information about the
          content you view, what websites you visit immediately prior to and
          after visiting this Site, and your system information and geographic
          information. The information generated by these cookies about your use
          of this Website will be transmitted to and stored by the applicable
          analytics services. The information collected by these analytics
          services allows us to analyze your use of this Site. The Analytics
          Tools may also transfer this information to third parties where
          required to do so by law, or where such third parties process the
          information on their behalf. You may refuse the use of cookies by
          selecting the appropriate settings on your browser, however, please
          note that if you do this you may not be able to use the full
          functionality of this Website.
        </p>
        <h2>METHOD OF COLLECTING INFORMATION</h2>
        <p>
          We may collect information from you passively. We use tracking tools
          including, but not limited to, Google Analytics, Google Webmaster,
          browser cookies, and web beacons for collecting information about your
          usage of the Website. Our advertisers may collect anonymous traffic
          information from their own assigned cookies to your browser. This
          Website may contain links to other websites. We are not responsible
          for the privacy practices of websites which we do not own, manage or
          control.
        </p>
        <p>
          Please find more details about our Cookie Policy here -
          <a href="https://www.qwikcilver.com/cookie-policy/">
            https://www.qwikcilver.com/cookie-policy/
          </a>
        </p>
        <p>
          We may be utilizing a third-party prospecting service for sending you
          emails relating to our product and services, if they had discovered
          that your profile meets our usual customer profile. If you prefer not
          to hear from us, simply notify us by clicking on the “Opt -out” link
          in the email.
        </p>
        <p>
          We may actively collect information from you on our webpage, during
          registration/Login process for the purpose of Authentication,
          Authorization and while availing of the different classes of
          products/Services provided by us.
        </p>
        <h2>PURPOSE AND METHOD OF USING INFORMATION COLLECTED</h2>
        <p>
          The data protection laws require a legal basis for our use of personal
          information. Our basis varies depending on the specific purpose for
          which we use personal information. We use your personal information
          in:
        </p>
        <ul>
          <li>
            Performance of a contract when we provide you with products or
            services, or communicate with you about them. This includes when we
            use your personal information to take and handle orders, deliver
            products and services, and process payments.
          </li>
          <li>
            Our legitimate business interests and the interests of our customers
            when we improve our services (including when we use your voice,
            email, mobile number to improve services), when we detect and
            prevent fraud and abuse in order to protect the security of our
            customers, ourselves, or others, and when we provide you with
            interest-based advertising.
          </li>
          <li>
            Your consent when we ask for your consent to process your personal
            information for a specific purpose that we communicate to you. When
            you consent to our processing your personal information for a
            specified purpose, you may withdraw your consent at any time and we
            will stop processing of your data for that purpose.
          </li>
          <li>
            Compliance with a legal obligation when we use your personal
            information to comply with laws.
          </li>
          <li>
            These and other legal basis depending on the purpose communicated to
            you for which we use personal information.
          </li>
        </ul>
        <p>We use your personal data to:</p>
        <ul>
          <li>tailor-make our Website to suit your interest.</li>
          <li>
            carry out our obligations arising from any contracts entered into
            between you and us and to provide you with the information and
            Services that you request from us;
          </li>
          <li>
            respond to your inquiries or to process your requests in relation to
            your information;
          </li>
          <li>optimize the Website for you based on your usage pattern;</li>
          <li>to get in touch with you when necessary;</li>
          <li>carry out market research campaigns;</li>
          <li>
            to preserve social history as governed by existing law or policy;
            and
          </li>
          <li>For auditing and logging purposes</li>
        </ul>
        <p>We use personal data internally to:</p>
        <ul>
          <li>
            send you confirmations, notifications, acknowledgments, and other
            details pertaining to the Services you have placed on the Website;
          </li>
          <li>
            administer our Website and for internal operations, including
            troubleshooting, data analysis, testing, research, statistical, and
            survey purposes;
          </li>
          <li>
            direct our efforts to improve features and facilities, including
            privacy features; and
          </li>
          <li>send you materials regarding:</li>
          <li>upcoming offers; and/or</li>
          <li>
            any information that we deem material in order for you to be a fully
            informed user and customer of, and visitor to the Website.
          </li>
          <li>
            Communicate with you about products, services, contests, promotions,
            discounts, incentives, surveys, and rewards offered by us and select
            partners;
          </li>
          <li>
            Send you information we think you may find useful or which you have
            requested from us about our products and services;
          </li>
          <li>Conduct surveys and collect feedback about our Services.</li>
        </ul>
        <h2>SHARING OF INFORMATION</h2>
        <p>
          We will not use information collected by you for any purpose other
          than to complete a transaction with you. We do not rent, sell or share
          your personal data and we will not disclose any of your personally
          identifiable information to third parties unless:
        </p>
        <ul>
          <li>we have your permission;</li>
          <li>it is to provide and facilitate provision of the Services;</li>
          <li>
            it is to help investigate, prevent or take action regarding unlawful
            and illegal activities; suspected fraud, potential threat to the
            safety or security of any person, violations of our Terms of Use or
            to defend against legal claims;
          </li>
          <li>it is with a successor to all or part of our business;</li>
          <li>
            special circumstances such as compliance with court orders,
            requests/order, notices from legal authorities or law enforcement
            agencies compel us to make such disclosure; and
          </li>
          <li>
            it forms part of the anonymous information we share with our
            sub-distributors and channel partners and/or advertisers on an
            aggregate basis.
          </li>
        </ul>
        <h2>THIRD PARTY PLATFORMS</h2>
        <p>
          You may be directed to third-party applications from our Website which
          we do not control. This Privacy Policy solely and exclusively governs
          your usage and experience of our Website. Accordingly, we undertake no
          liability whatsoever as regards your usage of these third-party
          applications and you may visit them at your own risk. We strongly
          encourage that you read the privacy policies of any third-party
          website/application you are directed to before using the same.
        </p>
        <p>
          If you choose to use chat rooms or other message areas or leave
          feedback, we will collect that information you provide to us. We
          retain this information as necessary to resolve disputes, provide
          customer support and troubleshoot problems as permitted by law.
        </p>
        <p>
          This Website and its contents do not give any party additional rights
          or remedies and should not be construed as a binding agreement.
        </p>
        <h2>DUE DILIGENCE AND SAFEGUARDS</h2>
        <p>
          Pine Labs uses reasonable physical, technical and administrative
          measures to safeguard personal data you provide through the Website or
          in connection with its Services.
        </p>
        <p>
          We apply these measures based on the sensitivity of the personal data
          we collect, use, and store, and the current state of technology. We
          protect your personal data through technical and organizational
          security measures to minimize risks associated with data loss, misuse,
          unauthorized access, and unauthorized disclosure and alteration.
        </p>
        <p>
          Pine Labs is also certified under the international standards (ISO
          27001) for information security and abides by the Reserve Bank of
          India’s master directions for Information Systems for Pre-Paid
          Instrument Issuers. We are also SOC1, Type 2 attested.
        </p>
        <p>
          Unfortunately, the transmission of your personal data via the internet
          is not completely secure and although we do our best to protect your
          personal data, we cannot guarantee the security of your data
          transmitted to us over the internet, and you acknowledge that any
          transmission is at your own risk.
        </p>
        <p>
          Pine Labs uses commercially reasonable efforts to evaluate the data
          protection practices of third parties that process electronic
          documents and files and will or may have access to or process personal
          data. Pine Labs requires such third parties to provide, at a minimum,
          the level of data protection required of Pine Labs under applicable
          data protection laws and regulations, including, but not limited to,
          the requirements to:
        </p>
        <ul>
          <li>
            Use commercially reasonable security measures in providing services
            to Pine Labs to preserve the security, integrity, and
            confidentiality of personal data, and to protect against
            unauthorized access and anticipated threats or hazards to personal
            data;
          </li>
          <li>
            Use personal data only for Pine Labs to provide its services, and
            not process personal data for any other purpose;
          </li>
          <li>
            Handle and maintain personal data in compliance with applicable data
            privacy and protection laws, rules, and regulations;
          </li>
          <li>
            Comply with obligations as required by all applicable data privacy
            and protection laws, rules, and regulations;
          </li>
          <li>
            Immediately notify Pine Labs about any actual or potential security
            breach affecting personal data processed on behalf of Pine Labs;
          </li>
          <li>
            Assist and support Pine Labs in dealing with requests from
            governmental authorities, data controllers, data subjects or data
            protection authorities, as applicable;
          </li>
          <li>
            Not transfer personal data to a third country unless expressly
            authorized to do so by Pine Labs; and
          </li>
          <li>
            Not engage another data processor without prior specific
            authorization of Pine Labs.
          </li>
        </ul>
        <h2>PROCEDURE FOR CORRECTING INACCURACIES IN THE INFORMATION</h2>
        <p>
          You may have certain rights related to your personal data, subject to
          local & applicable data protection laws. These rights may include:
        </p>
        <ul>
          <li>
            You can access and review personal data associated with your account
            at any time by sending us an e-mail to submit this request with us:
            e-mail ID:{" "}
            <a href="mailto:dpo@qwikcilver.com">dpo@qwikcilver.com</a>
          </li>
          <li>
            You also can request the following information: how we collect and
            use your personal data and why; the categories of personal data
            involved; the categories of recipients of your personal data; how we
            received your personal data and its source; our business purpose for
            using your personal data; and how long we use or store your personal
            data or the manner in which we determine relevant retention periods.
          </li>
          <li>
            You have a right to correct your personal data by sending us an
            e-mail to submit this request with us: e-mail ID:
            <a href="mailto:dpo@qwikcilver.com">dpo@qwikcilver.com</a>
          </li>
          <li>
            In certain situations as per the applicable law, you can ask that we
            delete/erase or stop using your personal data (and object to use of
            your personal data) or export your personal data. Please send us an
            e-mail to submit this request with us: e-mail ID:{" "}
            <a href="mailto:dpo@qwikcilver.com">dpo@qwikcilver.com</a>
          </li>
          <li>
            Where we rely on your consent to process your personal data, you
            have the right to decline consent and/or if provided, to withdraw
            consent at any time. This will not affect the lawfulness of
            processing prior to the withdrawal of your consent. At any time, you
            can request that we stop using your personal data for direct
            marketing purposes. See our Cookie notice, How can I control my
            cookies section of our Privacy Policy for more information on your
            choices.
          </li>
          <li>
            You have a right to provide us with guidance on the use, storage,
            and deletion of your personal data after your death.
          </li>
          <li>
            You have a right to raise questions or complaints with your local
            data protection authority at any time.
          </li>
        </ul>
        <p>
          We will take reasonable steps to verify your identity. If you have an
          account with us, we may verify you through your login of your account.
          If you do not have an account with us, we may seek a confirmation by
          email or seek other identification information, including
          government-issued identification, to verify your identity.
        </p>
        <p>
          You may authorize an agent to make a request to us on your behalf and
          we will verify the identity of your agent or authorized legal
          representative by either seeking confirmation from you or documents
          that establish the agent’s authorization to act on your behalf.
        </p>
        <p>
          Please note your rights and choices vary depending upon your location.
          Certain personal data may be exempt from such requests under
          applicable law. We need certain types of personal data so that we can
          provide the Services to you. If you ask us to delete it, you may no
          longer be able to access or use our Services.
        </p>
        <p>
          Please send an e-mail to:{" "}
          <a href="mailto:dpo@qwikcilver.com">DPO@qwikcilver.com</a>
        </p>
        <h2>HOW LONG DO WE KEEP YOUR PERSONAL DATA?</h2>
        <p>
          We will keep your personal data for no longer than necessary, for the
          purposes we have set out above. We will retain your information for as
          long as needed in order to provide the relevant Services to you or
          perform any contract we have with you and for a limited period
          afterward in order to deal with any queries or complaints.
        </p>
        <p>
          Any third parties that we engage will keep your data stored on their
          systems for as long as is necessary to provide the relevant Services
          to you or us. If we end our relationship with any third-party
          providers, we will make sure that they securely delete or return your
          personal data to us.
        </p>
        <p>
          We may retain personal data about you for statistical purposes (for
          example, to help us better advertise our Services). Where data is
          retained for statistical purposes, it will always be anonymized,
          meaning you will not be identifiable from that data.
        </p>
        <h2>CHANGE IN POLICY</h2>
        <p>
          We may update this Privacy Policy to reflect changes in our practices
          and service offerings. If we modify our Privacy Policy, we will update
          the “Last Modified” date at the top of this Privacy Policy. Any
          changes to the Privacy Policy will become effective when we post the
          revised Privacy Policy on the Website. Your use of the Website
          following these changes means that you accept the revised Privacy
          Policy.
        </p>
        <h2>DISPUTE RESOLUTION AND JURISDICTION</h2>
        <p>
          In the event of any disputes, controversies or claims arising out of
          or in connection with this Privacy Policy, the same shall be governed
          by and construed in accordance with the laws of India. You hereby
          irrevocably submit to the exclusive jurisdiction of the courts of New
          Delhi in relation to any disputes, controversies or claims arising out
          of or in connection with this Privacy Policy.
        </p>
        <h2>CONTACT US</h2>
        <p>
          If you have any questions, comments, or concerns regarding this
          Privacy Policy or Pine Labs’ data practices, please contact us at:
        </p>
        <p>
          Pine Labs Pvt Ltd
          <br /> Floor 5, Tower B, B4, Spaze I Tech Park, Sector 49
          <br /> Gurugram - 122018, Haryana, India
          <br />
          Telephone No: 1-800-3000-1264
          <br /> Email ID:{" "}
          <a href="mailto:dpo@qwikcilver.com">dpo@qwikcilver.com</a>
          <br /> If you have unresolved concerns, you have the right to complain
          to the relevant data protection authority where you live, work, or
          where you believe a breach may have occurred.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
